import { AxiosError } from 'axios'
import { toast } from '@/hooks/use-toast'
import { t } from 'i18next'
import { isPaymentRequiredError, ORG_MODULE_ACCESS_DENIED_ERROR_CODE } from '@/lib/axios'
import { tokens } from '@/locales/translations/tokens'

export function handleServerError(error: unknown) {
  if (isPaymentRequiredError(error)) {
    return
  }

  if (
    error &&
    typeof error === 'object' &&
    'orgModuleAccessDenied' in error &&
    (error as { orgModuleAccessDenied?: boolean }).orgModuleAccessDenied
  ) {
    return
  }

  let errMsg: string | undefined

  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    Number(error.status) === 204
  ) {
    errMsg = 'Content not found.'
  }

  if (error instanceof AxiosError) {
    if (
      error.response?.status === 403 &&
      error.response?.data?.errorCode === ORG_MODULE_ACCESS_DENIED_ERROR_CODE
    ) {
      return
    }
    if (error.response?.status === 403) {
      errMsg = t(tokens.ui.toasts.error.forbidden)
    } else {
      errMsg = error.response?.data?.title ?? error.response?.data?.message
    }
  }

  const title = errMsg ?? t(tokens.ui.toasts.error.generic)
  toast({ variant: 'destructive', title })
}
